export default __webpack_public_path__ + "static/media/template5.a674f0e8.png";